if (!customElements.get('store-availability')) {
  class StoreAvailability extends HTMLElement {
    constructor() {
      super();
      // if (!this.hasAttribute('available')) return;

      this.refreshHandler = this.handleRefreshBtnClick.bind(this);
      this.unavailableHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);

      this.getAvailability(this.dataset.variantId);

      document.addEventListener('on:variant:change', (event) => {
        this.updateVariantId(event.detail.variant.id);
        this.handleRefreshBtnClick();
      });

      this.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
      });

      let popUpTrigger = this.querySelector('.btn--magasin');
      if (popUpTrigger) {
        popUpTrigger.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          e.stopPropagation();
        });
      }
    }

    updateVariantId(variantId) {
      this.dataset.variantId = variantId;
    }

    /**
     * Handles 'click' events on the refresh button.
     */
    handleRefreshBtnClick() {
      this.getAvailability(this.dataset.variantId);
    }

    /**
     * Gets pick up availability for the current variant.
     * @param {string} variantId - Current variant id.
     */
    async getAvailability(variantId) {
      let { rootUrl } = this.dataset;
      if (!rootUrl.endsWith('/')) rootUrl = `${rootUrl}/`;

      try {
        const response = await fetch(`${rootUrl}variants/${variantId}/?section_id=store-availability`);
        if (!response.ok) throw new Error(response.status);

        const tmpl = document.createElement('template');
        tmpl.innerHTML = await response.text();

        this.renderAvailablityInfo(tmpl.content.querySelector('.shopify-section'));
      } catch (error) {
        const refreshBtn = this.querySelector('.js-refresh');
        if (refreshBtn) refreshBtn.removeEventListener('click', this.refreshHandler);
        this.renderUnavailableMsg();
      }
    }

    /**
     * Renders the availability info.
     * @param {string} sectionHtml - Fetched section HTML.
     */
    renderAvailablityInfo(sectionHtml) {
      const drawer = document.querySelector('.js-availability-drawer');
      if (drawer) drawer.remove();

      if (!sectionHtml.querySelector('.availability-status')) {
        this.innerHTML = '';
        this.removeAttribute('available');
        return;
      }

      this.setAttribute('available', '');
      this.innerHTML = sectionHtml.querySelector('.availability-status').outerHTML;
      document.body.appendChild(sectionHtml.querySelector('.js-availability-drawer'));

      const showDetailsBtn = this.querySelector('.js-show-availability-info');
      if (showDetailsBtn) {
        showDetailsBtn.addEventListener('click', () => {
          document.querySelector('.js-availability-drawer').open(showDetailsBtn);
        });
      }
      this.initSearchByZipcode();
    }

    /**
     * Renders a 'unavailable' message.
     */
    renderUnavailableMsg() {
      this.innerHTML = '';
      this.appendChild(this.unavailableHtml);
      this.querySelector('.js-refresh').addEventListener('click', this.refreshHandler);
    }

    initSearchByZipcode() {
      const zipcodeInput = document.getElementById('zipcode-input');
      const noMatchesMessage = document.getElementById('store-availability-unavailable-message');
      const storeList = document.querySelector('.store-availability-list');
      // Get all <li> elements with class "store-availability-list__entry"
      const storeItems = storeList.querySelectorAll('.store-availability-list__entry');
      const self = this;
      zipcodeInput.addEventListener('input', () => {
        self.filterStoreLocations(zipcodeInput, storeItems);
        let hiddenItemsCount = document.querySelectorAll('.store-availability-list__entry.hidden').length;
        if(hiddenItemsCount < storeItems.length) {
          noMatchesMessage.classList.add('hidden')
        } else {
          noMatchesMessage.classList.remove('hidden');
        }
      });
    }

    filterStoreLocations(zipcodeInput, storeItems) {
      // Get the user's entered value as a string
      const enteredInput = zipcodeInput.value.trim();

      // If nothing is entered, show all items
      if (!enteredInput) {
        storeItems.forEach((item) => {
          item.style.display = '';
          item.classList.remove('hidden');
        });
        return;
      }

      // Filter and show/hide items
      storeItems.forEach(item => {
        // Compare the entered value to the item's data-zipcode
        const itemZip = item.getAttribute('data-zipcode');
        const itemCity = item.getAttribute('data-city').toLowerCase();
        const itemFullStoreName = item.getAttribute('data-fullstore-name').toLowerCase();
        // Show only if there's a match (exact match used here)
        if (itemZip.startsWith(enteredInput) || itemCity.includes(enteredInput.toLowerCase()) || itemFullStoreName.includes(enteredInput.toLowerCase())) {
          item.style.display = '';
          item.classList.remove('hidden');
        } else {
          item.style.display = 'none';
          item.classList.add('hidden');
        }
      });


    }
  }

  customElements.define('store-availability', StoreAvailability);
}